import { TimeWindow } from "@apaq/orgkit-js";

export class TimeWindowHelper {
  public static isAllDay(timewindow: TimeWindow) {
    if(timewindow == null) return true;

    if(timewindow.startTime.getHours() === 0 && 
      timewindow.startTime.getMinutes() === 0 && 
      timewindow.startTime.getSeconds() === 0 &&
      timewindow.endTime.getHours() === 23 && 
      timewindow.endTime.getMinutes() === 59 && 
      timewindow.endTime.getSeconds() === 59
    ) {
      return true;
    }
    return false;
  }
}